import { SelectOptionType } from "../../../../../types/types";

export const SHOW_BUDGETED_TIME = true;
export const MAX_ASSIGNEES = 5;
export const CONTACTS_PAGE_SIZE = 20;
export const CONTACTS_SORT_COLUMN = "Name";
export const CONTACTS_SORT_ORDER: "asc" | "desc" = "asc";
export const ADD_WORK_INPUT_CLASSES =
  "font-normal text-[#333333] placeholder:text-[rgba(51,51,51,0.6)]";

export const NO_ROLE_OPTION: SelectOptionType = {
  value: "",
  label: "No role",
};
